export const PLACEHOLDER = "-";
export const ROW_ACTION_BAR_WIDTH = 80;
